import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=15b655ab&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15b655ab')) {
      api.createRecord('15b655ab', component.options)
    } else {
      api.reload('15b655ab', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=15b655ab&", function () {
      api.rerender('15b655ab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-26NSAI47OscGW/JS/comp/ImgFallback.vue"
export default component.exports